import React, { useState, useEffect } from 'react'
import style from './header.module.scss'
import {
    BarChart,
    Line,
    Area,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
  } from 'recharts';

const GraphVisitor = (props) => {


      
    useEffect(() => {

    }, [])
    
    return (
        <>
            <section className='sec_graphVisitor cardStyle mb-2 w-100 mt-2'>
                <a href="/" className={'btnMore'} />
                <div className='cardContent'>
                    <div className='titleCard'>
                        <h1>ผู้เยี่ยมชม</h1>
                        <div className='percent'>
                            <div className='icon icon_arrow_up'/>
                            <p>-0.1%</p>
                        </div>
                    </div>

                    <div className='graph'>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart
                        width={500}
                        height={300}
                        data={props.visitor.data}
                        margin={{
                            top: 10,
                            right: 15,
                            left: -25,
                            bottom: 0,
                        }}
                        >
                        <CartesianGrid strokeDasharray="3 3" />
                        <XAxis dataKey="name" />
                        <YAxis />
                        <Bar dataKey="count" fill="#1D2FB4" />
                        </BarChart>
                    </ResponsiveContainer>
                    </div>

                </div>
            </section>

            {/*<section className='sec_visitorProvince'>
                <div className='icon icon_eyes'/>
                <div className='groupTxt'>
                    <h1>{100}</h1>
                    <p>{1000}</p>
                </div>
            </section>*/}
        </>

    )
}
export default GraphVisitor